import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uiid from 'uuid';

import {
  StyledBoxGeneric,
  StyledBoxDown,
  StyledButton,
  StyledButtonAdd
} from './style';

import ExperienceCurrentItem from './ExperienceCurrentItem';
import Modal from '../../../core/Modal';
import { EXPERIENCE } from '../../../../constants/literals/modals';

const DRAFT = {
  title: '',
  summary: '',
  companyName: '',
  current: false,
  startDate: '',
  endDate: '',
  id: null
};

class Experience extends Component {
  constructor(props) {
    super(props);

    this.state = {
      draft: props.editExperience
        ? props.editExperience
        : { ...DRAFT, id: uiid.v4() },
      dataSavePastPositions: props.dataPastPositions,
      dataSaveCurrentPositions: props.dataCurrentPositions,
      edit: !!props.editExperience,
      btnIsDisabled: true
    };
  }

  onChangeDropDownInput = (key, month = false, e) => {
    let { draft } = this.state;
    let date = e.value;

    if (month) {
      date = draft[key] ? `${draft[key].split('-')[0]}-${date}` : `-${date}`;
    } else {
      date = draft[key] ? `${date}-${draft[key].split('-')[1]}` : `${date}-`;
    }

    draft = { ...draft, [key]: date };
    this.setState({ draft, btnIsDisabled: this.getBtnStatus(draft) });
  };

  onChangeChecked = check => {
    const { editExperience } = this.props;
    const { draft } = this.state;
    const cloneDraft = { ...draft };
    let updatedEndDate;

    if (editExperience) {
      const { endDate } = editExperience;
      updatedEndDate = check ? '' : endDate;
    } else {
      updatedEndDate = '';
    }

    cloneDraft.current = check;
    cloneDraft.endDate = updatedEndDate;

    this.setState({
      draft: {
        ...draft,
        current: check,
        endDate: updatedEndDate
      },
      btnIsDisabled: this.getBtnStatus(cloneDraft)
    });
  };

  getLabelMonth = date => {
    const { listMonths } = this.props;
    const defaultMonth = 'Mes';
    const month = date.split('-')[1];
    const label = month
      ? listMonths.find(objMonth => objMonth.value === month).text
      : defaultMonth;

    return label;
  };

  getLabelYear = date => {
    const { listYears } = this.props;
    const defaultYear = 'Año';
    const year = date.split('-')[0];
    const label = year
      ? listYears.find(objYear => objYear.value === year).text
      : defaultYear;

    return label;
  };

  getBtnStatus = data => {
    const { companyName, current, endDate, startDate, title } = data;

    const disabled = true;

    if (companyName !== '' && title !== '') {
      if (startDate.length === 7) {
        if ((current === false && endDate.length === 7) || current) {
          return false;
        }
      }
    }

    return disabled;
  };

  sortExperiences = experiences => {
    const sortCurrentExperience = experiences.sort((a, b) => {
      if (b.endDate > a.endDate) {
        return 1;
      }
      if (a.endDate > b.endDate) {
        return -1;
      }
      return 0;
    });

    return sortCurrentExperience;
  };

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { draft } = this.state;
    let { dataSaveCurrentPositions, dataSavePastPositions } = this.state;

    dataSaveCurrentPositions = dataSaveCurrentPositions.filter(
      item => item.id !== draft.id
    );
    dataSavePastPositions = dataSavePastPositions.filter(
      item => item.id !== draft.id
    );

    if (draft.current) {
      dataSaveCurrentPositions = [...dataSaveCurrentPositions, draft];
    } else {
      dataSavePastPositions = [...dataSavePastPositions, draft];
    }

    onAcceptModal(dataSaveCurrentPositions, dataSavePastPositions);
  };

  handleChange = (value, key) => {
    const { draft } = this.state;
    let cloneDraft = { ...draft };

    cloneDraft = { ...cloneDraft, [key]: value };

    this.setState({
      draft: cloneDraft,
      btnIsDisabled: this.getBtnStatus(cloneDraft)
    });
  };

  handlePlus = () => {
    const { draft } = this.state;
    let { dataSaveCurrentPositions, dataSavePastPositions } = this.state;

    if (draft.current) {
      dataSaveCurrentPositions = [...dataSaveCurrentPositions, draft];
    } else {
      dataSavePastPositions = [...dataSavePastPositions, draft];
    }

    this.setState({
      dataSaveCurrentPositions,
      dataSavePastPositions,
      draft: { ...DRAFT, id: uiid.v4() }
    });
  };

  render() {
    const { listMonths, listYears, onCloseModal } = this.props;
    const { draft, edit, btnIsDisabled } = this.state;

    return (
      <Modal
        title={edit ? EXPERIENCE.TITLE_MOD : EXPERIENCE.TITLE_ADD}
        clickCloseIcon={onCloseModal}
      >
        <StyledBoxGeneric>
          <ExperienceCurrentItem
            key={draft.id}
            companyName={draft.companyName}
            checkedCurrentWork={draft.current}
            listMonths={listMonths}
            listYears={listYears}
            onChangeCheckbox={this.onChangeChecked}
            onChangeInputCompany={e => this.handleChange(e, 'companyName')}
            onChangeInputDescription={e => this.handleChange(e, 'summary')}
            onChangeInputPosition={e => this.handleChange(e, 'title')}
            onSelectFromMonth={e =>
              this.onChangeDropDownInput('startDate', true, e)
            }
            onSelectFromYear={e =>
              this.onChangeDropDownInput('startDate', false, e)
            }
            onSelectUntilMonth={e =>
              this.onChangeDropDownInput('endDate', true, e)
            }
            onSelectUntilYear={e =>
              this.onChangeDropDownInput('endDate', false, e)
            }
            selectedFromMonth={this.getLabelMonth(draft.startDate)}
            selectedFromYear={this.getLabelYear(draft.startDate)}
            selectedUntilMonth={this.getLabelMonth(draft.endDate)}
            selectedUntilYear={this.getLabelYear(draft.endDate)}
            summary={draft.summary}
            title={draft.title}
          />

          <StyledBoxDown>
            <StyledButton onClick={onCloseModal} modal>
              {EXPERIENCE.CANCEL}
            </StyledButton>
            <StyledButton
              onClick={this.handleAccept}
              secondary
              disabled={btnIsDisabled}
            >
              {EXPERIENCE.ACCEPT}
            </StyledButton>
          </StyledBoxDown>
          {!edit && (
            <StyledButtonAdd onClick={this.handlePlus}>
              {EXPERIENCE.SAVE_AND_ADD}
            </StyledButtonAdd>
          )}
        </StyledBoxGeneric>
      </Modal>
    );
  }
}

Experience.propTypes = {
  editExperience: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      summary: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      companyName: PropTypes.string,
      current: PropTypes.bool,
      expanded: PropTypes.bool
    })
  ),
  dataCurrentPositions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      summary: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      companyName: PropTypes.string,
      current: PropTypes.bool,
      expanded: PropTypes.bool
    })
  ),
  dataPastPositions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      summary: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      companyName: PropTypes.string,
      current: PropTypes.bool,
      expanded: PropTypes.bool
    })
  ),
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ),
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ),
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func
};

Experience.defaultProps = {
  editExperience: null,
  dataCurrentPositions: [],
  dataPastPositions: []
};

export default Experience;
